export default "__VITE_ASSET__BTIxCPl6__"